import Divider from "@components/Divider";
import styles from "./Divider.module.scss";

import cx from "classnames";
import { usePageContext } from "@providers/PageProvider";
import { discoverPage } from "@utils/helper";
import _ from "lodash";

const View = ({ className }: any) => {
  const { pageData } = usePageContext();
  const data = discoverPage.formatDivider(pageData);

  return (
    <section data-scroll-section className={cx(styles.section, className)}>
      <Divider
        labelProps={{ className: styles.label }}
        light={true}
        label={
          <>
            <div className={cx("ama-section-title", styles.title)}>
              {_.get(data, "title")}
            </div>
            <div className={cx("ama-content", styles.content)}>
              {_.get(data, "content")}
            </div>
          </>
        }
      />
    </section>
  );
};
export default View;
